var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-plot-overlay--container"},[_c('asc-switch',{attrs:{"label":_vm.title},model:{value:(_vm.overlayStatus),callback:function ($$v) {_vm.overlayStatus=$$v},expression:"overlayStatus"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }